import {environment} from '@environments/environment';
import {Config} from '@core/types';

export const CONFIG: Config = {
  BASE_API_URL: environment.BASE_API_URL,
  API_PREFIX: environment.API_PREFIX,
  isDebug: () => environment.ENV === 'dev',
  TTL_APP: environment.TTL_APP,
  TTL_COMPANY: environment.TTL_COMPANY,
}
